<template>
  <div class="base-screen-tab-list-view pb-6">
    <!-- Search and filter options -->
    <div class="search-and-options pt-6">
      <search-bar
        v-model="searchInputModel"
        class="search-bar"
        :result-count="resultCount"
        :loading="loading"
      />
      <slot name="filters"></slot>
    </div>

    <!-- List of screen cards -->
    <slot name="screen-cards">
      <screen-card-skeleton-loader v-for="i in 5" :key="i" />
    </slot>
  </div>
</template>

<script>
import SearchBar from '@/components/Common/SearchBar';
import ScreenCardSkeletonLoader from './ScreenCardSkeletonLoader';

export default {
  name: 'BaseScreenTabListView',
  components: {
    SearchBar,
    ScreenCardSkeletonLoader,
  },
  props: {
    searchInput: {
      type: String,
      default: null,
    },
    resultCount: {
      type: Number,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    searchInputModel: {
      get: function () {
        return this.searchInput;
      },
      set: function (value) {
        this.$emit('update:searchInput', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.base-screen-tab-list-view {
  --screen-card-width: 750px;
  --gap-between-screen-cards: 24px;
  --search-bar-width: 500px;

  display: grid;
  grid-template-columns: var(--screen-card-width);
  justify-content: center;

  > * {
    margin-bottom: var(--gap-between-screen-cards);
  }

  .search-and-options {
    .search-bar {
      max-width: var(--search-bar-width);
    }

    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 24px;
  }
}
</style>
